export const ABILITY_STATUS_TYPES = {
  'EN REVISIÓN': {
    color: 'warning',
    description: 'En proceso de revisión',
    label: 'EN REVISIÓN'
  },
  HABIL: {
    color: 'success',
    description: 'HÁBIL (Cumple con los requisitos de inscripción en el Registro de Proveedores)',
    label: 'HÁBIL',
    withIcon: true
  },
  INHABIL: {
    color: 'error',
    description: 'INHÁBIL (No cumple con los requisitos de inscripción en el Registro de Proveedores)',
    label: 'INHÁBIL'
  },
  PENDIENTE: {
    color: 'warning',
    description: 'Pendiente por documentación',
    label: 'EN REVISIÓN'
  },
  'SIN INFORMACIÓN': {
    color: 'default',
    description: 'Sin información disponible',
    label: 'SIN INFORMACIÓN'
  },
  'SIN INFORMACION': {
    color: 'default',
    description: 'Sin información disponible',
    label: 'SIN INFORMACIÓN'
  }
}

export const ANTIUNION_PRACTICES = {
  'PRÁCTICAS ANTISINDICALES': {
    key: 'PRÁCTICAS ANTISINDICALES',
    negative:
      'Proveedor ha sido condenado por delitos concursales establecidos en el Código Penal o delitos tributarios o incumplimiento contractual o prácticas antisindicales o infracción a los derechos fundamentales del trabajador o ha sido condenado en Chile o en el extranjero por cohecho, lavado de activos o financiamiento del terrorismo.',
    positive:
      'Proveedor cumple con no haber sido condenado por delitos concursales establecidos en el Código Penal, delitos tributarios, incumplimiento contractual, prácticas antisindicales o infracción a los derechos fundamentales del trabajador. Tampoco ha sido condenado en Chile o en el extranjero por cohecho, lavado de activos o financiamiento del terrorismo.',
    subtitle: 'Tribunales de Justicia',
    title: 'Sentencias Informadas por Tribunales'
  }
}

export const CAUSAL_TOOLTIP = `Por el momento no se ha podido validar esta causal a través de la fuente oficial. Intenta consultar en unas horas más esta sección.`

export const CERTIFICATE_ABILITY_STATUSES = [
  {
    color: 'success',
    description:
      'Cumple con los requisitos para contratar con el Estado de acuerdo a las causales establecidas en el Reglamento de la Ley N° 19.886.',
    label: 'HÁBIL'
  },
  {
    color: 'error',
    description: 'No cumple con uno o más de los requisitos para contratar con el Estado.',
    label: 'INHÁBIL'
  },
  {
    color: 'warning',
    description:
      'Proveedor se encuentra en proceso de validación con fuentes oficiales para Ingreso al sistema. Su estado de habilidad aparecerá a contar del día hábil siguiente.',
    label: 'EN REVISIÓN'
  },
  {
    color: 'default',
    description: 'Proveedor no tiene contrato vigente con el Registro de Proveedores.',
    label: 'SIN INFORMACIÓN'
  }
]

export const CERTIFICATE_ABILITY_STATUSES_FOREIGN = [
  {
    color: 'success',
    description:
      'Cumple con los requisitos para contratar con el Estado pues se constató que no se encuentra en la lista de personas naturales y jurídicas declaradas inelegibles para la adjudicación de contratos, elaboradas por instituciones multilaterales.',
    label: 'HÁBIL'
  },
  {
    color: 'error',
    description:
      'No cumple con los requisitos para contratar con el Estado pues se constató que se encuentra en la lista de personas naturales y jurídicas declaradas inelegibles para la adjudicación de contratos, elaboradas por instituciones multilaterales.',
    label: 'INHÁBIL'
  },
  {
    color: 'warning',
    description:
      'Proveedor se encuentra en proceso de validación con fuentes oficiales para Ingreso al sistema. Su estado de Habilidad aparecerá a contar del día hábil siguiente.',
    label: 'EN REVISIÓN'
  },
  {
    color: 'default',
    description: 'Proveedor no tiene contrato vigente con el Registro de Proveedores.',
    label: 'SIN INFORMACIÓN'
  }
]

export const CERTIFICATE_SCHEDULED_MILLISECONDS = 60000

export const CERTIFICATE_STATUSES = {
  1: 'PENDIENTE',
  2: 'EN PROCESO',
  3: 'TERMINADO OK',
  4: 'TERMINADO NOK'
}

export const COMPANY_SIZE_BY_INCOME_BRACKET = {
  1: {
    details: 'Renta anual 0 a 13,5 UTA',
    size: 'Micro'
  },
  2: {
    details: 'Renta anual 13.5 a 30 UTA',
    size: 'Micro'
  },
  3: {
    details: 'Renta anual 30 a 50 UTA',
    size: 'Micro'
  },
  4: {
    details: 'Renta anual 50 a 70 UTA',
    size: 'Micro'
  },
  5: {
    details: 'Renta anual 70 a 90 UTA',
    size: 'Micro'
  },
  6: {
    details: 'Renta anual 90 a 120 UTA',
    size: 'Pequeña'
  },
  7: {
    details: 'Renta anual 120 a 240 UTA',
    size: 'Pequeña'
  },
  8: {
    details: 'Renta anual mayor de 240 UTA',
    size: 'Grande'
  },
  9: {
    details: 'Renta anual mayor de 240 UTA',
    size: 'Grande'
  },
  10: {
    details: 'Renta anual mayor de 240 UTA',
    size: 'Grande'
  },
  11: {
    details: 'Renta anual mayor de 240 UTA',
    size: 'Grande'
  },
  12: {
    details: 'Renta anual mayor de 240 UTA',
    size: 'Grande'
  },
  13: {
    details: 'Renta anual mayor de 240 UTA',
    size: 'Grande'
  }
}

export const COMPANY_SIZE_BY_SALES_INCOME = {
  1: {
    details: 'La información tributaria declarada, no permite determinar un monto estimado de ventas',
    size: 'Micro'
  },
  2: {
    details: 'Facturación anual 0,01 UF a 200 UF',
    size: 'Micro'
  },
  3: {
    details: 'Facturación anual 200,01 UF a 600 UF',
    size: 'Micro'
  },
  4: {
    details: 'Facturación anual 600,01 UF a 2.400 UF',
    size: 'Micro'
  },
  5: {
    details: 'Facturación anual 2.400,01 UF a 5.000 UF',
    size: 'Pequeña'
  },
  6: {
    details: 'Facturación anual 5.000,01 UF a 10.000 UF',
    size: 'Pequeña'
  },
  7: {
    details: 'Facturación anual 10.000,01 UF a 25.000 UF',
    size: 'Pequeña'
  },
  8: {
    details: 'Facturación anual 25.000,01 UF a 50.000 UF',
    size: 'Mediana'
  },
  9: {
    details: 'Facturación anual 50.000,01 UF a 100.000 UF',
    size: 'Mediana'
  },
  10: {
    details: 'Facturación anual 100.000,01 UF a 200.000 UF',
    size: 'Grande'
  },
  11: {
    details: 'Facturación anual 200.000,01 UF a 600.000 UF',
    size: 'Grande'
  },
  12: {
    details: 'Facturación anual 600.000,01 UF a 1.000.000 UF',
    size: 'Grande'
  },
  13: {
    details: 'Facturación anual mayor de 1.000.000 UF',
    size: 'Grande'
  }
}

export const CONTRACTUAL_BEHAVIOR_TABS = ['Comportamiento base', 'Comportamiento por evaluación de contratos']

export const DEFAULT_ROWS_PER_PAGE = 5

export const DISABILITY_REASONS = {
  COHECHO: {
    duration:
      'Se podrá extender por el tiempo que dure la pena de inhabilitación establecida en el artículo 251 quáter del Código Penal, o, en su caso, la condena.',
    howIsItSolved: [
      'Para esta inhabilidad no existe método de solución anticipado, dado que requiere que se cumpla el plazo indicado en la resolución judicial ejecutoriada.'
    ],
    key: 'COHECHO',
    negative:
      'El proveedor ha sido condenado por cualquiera de los delitos de cohecho o financiamiento del terrorismo contemplados en el título V del Libro Segundo del Código Penal.',
    positive:
      'El proveedor cumple con no haber sido condenado por cualquiera de los delitos de cohecho o financiamiento del terrorismo contemplados en el título V del Libro Segundo del Código Penal.',
    subtitle: 'Tribunales de Justicia',
    title: 'Condenas por delitos de cohecho o financiamiento del terrorismo'
  },
  'DELITOS CONCURSALES': {
    duration:
      'La inhabilidad durará el plazo indicado en la sentencia. En el caso de condena por delitos establecidos en los numerales 4° párrafos primero, segundo, tercero y quinto; 10° párrafo tercero; 22°; 23° párrafo primero; 24° párrafo tercero, y 25° del artículo 97 del Código Tributario, la inhabilidad tendrá una duración de dos años desde ejecutoriada la sentencia respectiva.',
    howIsItSolved: ['El proveedor sólo volverá a encontrarse hábil al cumplirse el plazo indicado en la sentencia.'],
    key: 'DELITOS CONCURSALES',
    negative:
      'El proveedor ha sido condenado por cualquiera de los delitos concursales contemplados en el Código Penal o en los delitos contemplados en el Código Tributario.',
    positive:
      'Cumple con no haber sido condenado por cualquiera de los delitos concursales contemplados en el Código Penal no en los delitos contemplados en el Código Tributario.',
    subtitle: 'Tribunales de Justicia',
    title: 'Delitos concursales establecidos en el Código Penal y en el Código Tributario'
  },
  'DEUDAS LABORALES': {
    duration:
      'La inhabilidad por deudas previsionales o de salud se mantendrá por todo el tiempo que se encuentre configurada la causal.',
    howIsItSolved: [
      'El proveedor deberá pagar la(s) deuda(s) que originan la inhabilidad (deudas previsionales o de salud por más de 12 meses por sus trabajadores dependientes) en la entidad previsional y/o de salud correspondiente.',
      'Una vez pagadas dichas deudas, esta información deberá ser actualizada por la Dirección del Trabajo, fuente desde la cual la Dirección ChileCompra debe obtener la información a efectos de que se realice el cambio en el estado de habilidad del proveedor en el Registro de Proveedores.'
    ],
    key: 'DEUDAS LABORALES',
    negative:
      'El proveedor registra deudas previsionales o de salud por más de 12 meses por sus trabajadores dependientes, lo que se acreditará mediante certificado de la autoridad competente.',
    positive:
      'El proveedor no registra deudas previsionales o de salud por más de 12 meses por sus trabajadores dependientes, lo que se acreditará mediante certificado de la autoridad competente.',
    subtitle: 'Boletín Laboral Dirección del Trabajo',
    title: 'Deudas previsionales'
  },
  'DEUDAS TRIBUTARIAS': {
    duration:
      'La inhabilidad por deudas tributarias durará mientras se encuentre pendiente el pago de dichas deudas, o bien tendrá una duración de dos años desde que la respectiva resolución judicial que se pronuncia sobre la efectividad de la deuda se encuentre ejecutoriada.',
    howIsItSolved: [
      'El proveedor puede pagar la(s) deuda(s) que originan la inhabilidad (deudas tributarias por un monto total superior a 500 UTM por más de un año, o superior a 200 UTM e inferior a 500 UTM por un periodo superior a dos años) o suscribir un convenio de pago con Tesorería General de la República.',
      'En ambos casos, es decir, pagadas las referidas deudas o existiendo un convenio de pago vigente, con la información proporcionada por Tesorería General de la República, la Dirección ChileCompra actualizará la información sobre el estado de habilidad en el Registro de Proveedores.',
      'Asimismo, se debe tener presente que en caso de que existan juicios pendientes sobre la efectividad de las deudas tributarias que da origen a la inhabilidad, el proveedor podrá informar tal situación a ChileCompra mediante el envío de una carta u oficio, en que se de cuenta de esta situación, entregado en la oficina de partes de la institución, acompañada/o del certificado de deudas actualizado a la fecha de la carta junto al eBook (expediente virtual) del juicio. Con dicha información, la Dirección ChileCompra, evaluará los antecedentes a fin de determinar cuál es el estado de habilidad del proveedor.'
    ],
    key: 'DEUDAS TRIBUTARIAS',
    negative:
      'El proveedor registra una o más deudas tributarias por un monto total superior a 500 UTM por más de un año, o superior a 200 UTM e inferior a 500 UTM por un período superior a 2 años.',
    positive:
      'El proveedor no registra una o más deudas tributarias por un monto total superior a 500 UTM por más de un año, o superior a 200 UTM e inferior a 500 UTM por un período superior a 2 años.',
    subtitle: 'Tesorería General de la República',
    title: 'Deudas tributarias'
  },
  'DOCUMENTACIÓN FALSA': {
    duration: 'La inhabilidad durará dos años desde ejecutoriada la resolución que disponga la inhabilidad.',
    howIsItSolved: [
      'Se declara inhábil al proveedor que hubiese informado, antecedentes maliciosamente falsos, enmendados o tergiversados o que se presenten de una forma que claramente induce a error respecto de sus beneficiarios finales o cualquier otro elemento declarado al momento de solicitar su inscripción y evaluación de habilidad en el Registro de Proveedores.'
    ],
    key: 'DOCUMENTACIÓN FALSA',
    negative:
      'El proveedor ha presentado uno o más documentos falsos al Registro Nacional de Proveedores declarado así por sentencia judicial ejecutoriada.',
    positive: 'El proveedor no ha declarado documentación falsa ante el Registro Nacional de Proveedores.',
    subtitle: 'Tribunales de Justicia',
    title: 'Documentación falsa'
  },
  ELIMINACIÓN: {
    duration: 'No existe método alternativo para salir de la eliminación y recuperar la habilidad.',
    howIsItSolved: [
      'Procederá en caso de que se haya suspendido al proveedor por un periodo total de 24 meses dentro de los últimos 5 años contados desde la sanción más reciente.'
    ],
    key: 'ELIMINACIÓN',
    negative:
      'El proveedor ha sido eliminado del Registro de Proveedores por resolución fundada de la Dirección de Compras.',
    positive:
      'Cumple con no haber sido eliminado del Registro de Proveedores por resolución fundada de la Dirección de Compras.',
    subtitle: 'Dirección ChileCompra',
    title: 'Eliminación del Registro de Proveedores'
  },
  'FALTA DE DILIGENCIA': {
    duration:
      'La inhabilidad se podrá aplicar por hasta dos años contados desde la fecha en que se encuentre firme o ejecutoriada la sentencia respectiva.',
    howIsItSolved: [
      'Esta inhabilidad aplicará a las personas naturales o jurídicas que hayan sido condenados en virtud de una sentencia firme o ejecutoriada por incumplimiento contractual respecto de un contrato de suministro y prestación de servicios suscrito con alguno de los organismos sujetos a esta ley, derivado de culpa o falta de diligencia en el cumplimiento de sus obligaciones.'
    ],
    key: 'FALTA DE DILIGENCIA',
    negative: 'Ha sido condenado por incumplimiento contractual.',
    positive: 'Cumple con no haber sido condenado por incumplimiento contractual.',
    subtitle: 'Tribunales de Justicia',
    title: 'Condenas por incumplimiento contractual derivado de culpa o falta de diligencia'
  },
  'LAVADO DE ACTIVO': {
    duration:
      'Se podrá extender por el tiempo que dure la pena de inhabilitación establecida en el artículo 251 quáter del Código Penal, o, en su caso, la condena.',
    howIsItSolved: [
      'Para esta inhabilidad no existe método de solución anticipado, dado que requiere que se cumpla el plazo indicado en la resolución judicial ejecutoriada.'
    ],
    key: 'LAVADO DE ACTIVO',
    negative:
      'Ha sido condenado por los delitos de lavado de activos, establecido en el Párrafo 2 del Título V del Libro II del Código Penal, lavado de activos establecido en el Título II de la ley N° 19.913.',
    positive:
      'Cumple con no haber sido condenado por los delitos de lavado de activos, establecido en el Párrafo 2 del Título V del Libro II del Código Penal, lavado de activos establecido en el Título III de la ley N° 19.913.',
    subtitle: 'Bancos Internacionales',
    title: 'Condenas por Lavado de Activos'
  },
  'LISTAS NEGRAS': {
    duration:
      'Se podrá extender por el tiempo que dure la pena que dio lugar a su inclusión en la Lista de proveedores inelegibles.',
    howIsItSolved: [
      'La Dirección de Compras y Contratación Pública declarará inhábiles a las personas incluidas en las listas de personas naturales y jurídicas, incluyendo a sus accionistas y beneficiarios finales, declaradas inelegibles para la adjudicación de contratos, elaboradas por las instituciones financieras multilaterales.'
    ],
    key: 'LISTAS NEGRAS',
    negative:
      'Ha sido declarado inelegible para la adjudicación de contratos por instituciones financieras multilaterales.',
    positive:
      'Cumple con no haber sido declarado inelegible para la adjudicación de contratos por instituciones financieras multilaterales.',
    subtitle: 'Instituciones financieras multilaterales',
    title: 'Listas Negras Internacionales'
  },
  'PRÁCTICAS ANTISINDICALES': {
    duration:
      'La inhabilidad se podrá aplicar por hasta dos años contados desde la fecha en que se encuentre firme o ejecutoriada la sentencia respectiva.',
    howIsItSolved: [
      'Esta inhabilidad aplicará a quienes hayan sido condenados por prácticas antisindicales o infracción de los derechos fundamentales del trabajador.'
    ],
    key: 'PRÁCTICAS ANTISINDICALES',
    negative:
      'Ha sido condenado por prácticas antisindicales o infracción a los derechos fundamentales del trabajador.',
    positive:
      'Cumple con no haber sido condenado por prácticas antisindicales o infracción a los derechos fundamentales del trabajador.',
    subtitle: 'Dirección del Trabajo ',
    title: 'Prácticas antisindicales'
  },
  QUIEBRA: {
    duration:
      'Tratándose del deudor declarado en quiebra, la inhabilidad durará mientras se encuentre configurada la causal, salvo que exista condena por delitos concursales establecidos en el Título IX del Libro II del Código Penal, en cuyo caso la inhabilidad tendrá una duración de dos años, contados desde la fecha en que se encuentre firme o ejecutoriada la sentencia.',
    howIsItSolved: [
      'Actualmente el concepto de “quiebra” se asocia a “Liquidación”, por lo cual, si el proveedor se encuentra en dicha situación, pero posteriormente existe algún tipo de recurso sobre dicha causal, el proveedor no requiere realizar ninguna acción, dado que esta información la procesará de forma automática el registro.'
    ],
    key: 'QUIEBRA',
    negative: 'Ha sido declarado en liquidación concursal por resolución judicial ejecutoriada.',
    positive: 'Cumple con no haber sido declarado en liquidación concursal por resolución judicial ejecutoriada.',
    subtitle: 'Superintendencia de Insolvencia y Reemprendimiento',
    title: 'Liquidación concursal'
  },
  SUSPENSIÓN: {
    duration: 'No existe método alternativo para salir de la suspensión y recuperar la habilidad.',
    howIsItSolved: [],
    key: 'SUSPENSIÓN',
    negative:
      'Se encuentra suspendido del Registro Nacional de Proveedores por resolución fundada de la Dirección de Compras.',
    positive:
      'No se encuentra suspendido del Registro Nacional de Proveedores por resolución fundada de la Dirección de Compras.',
    subtitle: 'Dirección ChileCompra',
    title: 'Suspensión del Registro de Proveedores'
  }
}

export const DISABLED_CONTRACT_TEXT = 'INHABILITADO PARA CONTRATAR CON EL ESTADO'

export const INFO_FOREING_TEXT = `En virtud de los principios de libre concurrencia y de igualdad ante las bases, debe considerarse que los proveedores extranjeros cumplen con la habilidad en el Registro de Proveedores, cuando aquélla haya sido exigida como requisito para contratar, a la luz del artículo 16 de la ley N° 19.886.`

export const LEGAL_DOCUMENT_NAMES_DICTIONARY = {
  AUTHORIZATION_DOCUMENT_MARKET_FOREIGN: 'Acreditación de Actividad Comercial',
  CERTIFICATE_ANNOTATIONS: 'Certificado de anotaciones vigentes',
  CERTIFICATE_STATUTE: 'Estatuto actualizado',
  CERTIFICATE_VALIDITY: 'Certificado de Vigencia de la Sociedad',
  CERTIFICATE_VALIDITY_PERSON: 'Poderes del Representante Legal',
  DNI: 'Cédula de Identidad',
  FOREIGN_IDENTIFICATION_DOCUMENT: 'Documento de Identificación Extranjero',
  LEGALIZED_PHOTOCOPY_IDENTITY_LEGAL_REPRESENTATIVE: 'Cédula de Identidad del Representante Legal',
  OPTIONAL: 'Documento Adicional',
  PARTNERSHIP_CONSTITUTION: 'Constitución de la Sociedad',
  PARTNERSHIP_UPDATE: 'Modificación de la Sociedad'
}

export const LEGAL_DOCUMENT_NAMES_TRANSLATION_DICTIONARY = {
  CDAN: 'CERTIFICATE_ANNOTATIONS',
  CDE: 'CERTIFICATE_STATUTE',
  CIPN: 'DNI',
  CIRL: 'LEGALIZED_PHOTOCOPY_IDENTITY_LEGAL_REPRESENTATIVE',
  CST: 'PARTNERSHIP_CONSTITUTION',
  CVS: 'CERTIFICATE_VALIDITY',
  CVSO: 'CERTIFICATE_VALIDITY_PERSON',
  DCBS: 'AUTHORIZATION_DOCUMENT_MARKET_FOREIGN',
  DIEX: 'FOREIGN_IDENTIFICATION_DOCUMENT',
  MST: 'PARTNERSHIP_UPDATE',
  OTDL: 'OPTIONAL'
}

export const OFFSET_LIMIT_MEMBERSHIP = 100

export const RESOLUTION_LABELS = {
  DEC: 'Número de decreto',
  OTR: 'Número de documento',
  RES: 'Número de resolución'
}

export const SANC_DOCUMENT_TYPES = {
  AM: 'AMON',
  BG: 'CGAR',
  BP: 'BLPR',
  MT: 'MULT',
  SP: 'SUSP',
  TC: 'TANC'
}

export const SCORE_RANGE_COLORS = [
  {
    color: 'black1',
    max: {
      type: 'exclusive',
      value: 3
    },
    min: {
      type: 'inclusive',
      value: 0
    }
  },
  {
    color: 'black1',
    max: {
      type: 'exclusive',
      value: 3
    },
    min: {
      type: 'inclusive',
      value: 0
    }
  },
  {
    color: 'black1',
    max: {
      type: 'inclusive',
      value: 5
    },
    min: {
      type: 'inclusive',
      value: 4
    }
  }
]

export const TYPE = [
  {
    name: 'Licitación',
    value: 'BID'
  },
  {
    name: 'Orden de compra',
    value: 'PO'
  }
]

export const USER_TYPE = {
  PROVIDER: 'Proveedor',
  PUBLIC: 'Publico',
  SELLER: 'Comprador'
}

export const WSP_COMPANY_TYPE_DICTIONARY = {
  1: 'Persona natural',
  2: 'Persona jurídica comercial',
  3: 'Sin personalidad jurídica',
  4: 'Sociedades extranjeras',
  5: 'Instituciones fiscales',
  6: 'Municipalidades',
  7: 'Organismos internacionales',
  8: 'Organizaciones sin fines de lucro',
  99: 'No clasificados'
}

export const WORK_REGISTER_PAGE_SIZE = 5

export const WORK_REGISTER_CODES = {
  CONSULTANTS: '2',
  CONTRACTORS: '1'
}

export const DNI_PARAM = ':rut'

export const WORK_REGISTER_ENDPOINTS = {
  MINVU: 'minvu',
  MOP: 'mop'
}

export const REGISTRY_CODE_BY_KEY = {
  [WORK_REGISTER_CODES.CONSULTANTS]: 'consultants',
  [WORK_REGISTER_CODES.CONTRACTORS]: 'contractors'
}

export const SANCTIONS_ROWS_PER_PAGE = 10

export const VOID_STATES = {
  ACTIVE: 'VIGENTE',
  VOIDED: 'ANULADA'
}
